import { useTranslation } from 'react-i18next';

import { Subtitle2 } from '@myphx-engineering/phx-design-system';

import { useProgramTerms } from '../../../../../hooks/use-program-terms';
import { isPharmacySpecificOffer } from '../../../../../util/offers/is-pharmacy-specific-offer';
import type { PricingCardElementProps } from '../../common/shared';

export const SelfPayPricingCardLine1 = ({
    medication,
    offer,
}: Omit<PricingCardElementProps, 'hasIncentivePricing' | 'savings'>) => {
    const { t } = useTranslation('lilly');

    const terms = useProgramTerms(medication, 'self-pay');

    const pharmacySpecific = isPharmacySpecificOffer(offer);

    if (pharmacySpecific) {
        return <Subtitle2>{t('fill.selfPay.pricing.noCard')}</Subtitle2>;
    }

    if (terms?.savingsCard) {
        return (
            <Subtitle2>
                {t('fill.selfPay.pricing.withCard', {
                    cardName: terms.savingsCard.name,
                })}
            </Subtitle2>
        );
    }

    return <Subtitle2>{t('fill.selfPay.pricing.noCard')}</Subtitle2>;
};
